import { FaPlay } from 'react-icons/fa6';
import { actions as modalActions } from '#reducers/modal.reducer';
import VideoPlayer from '#components/modal/VideoPlayer.modal';
var ProofPage = function ProofPage() {
  var dispatch = useDispatch();

  // useEffect(() => {

  // }, []);

  var handleOnPlay = function handleOnPlay() {
    dispatch({
      type: modalActions.show,
      payload: {
        component: /*#__PURE__*/React.createElement(VideoPlayer, {
          url: "/public/videos/proof_low_music.mp4"
        })
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "proof"
  }, /*#__PURE__*/React.createElement("div", {
    className: "proof__body"
  }, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/proof/page1-with-placeholder.jpg"
  }), /*#__PURE__*/React.createElement("div", {
    className: "proof__placeholder",
    onClick: handleOnPlay
  }, /*#__PURE__*/React.createElement(FaPlay, null), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/proof/video-placeholder.jpg"
  }))), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/proof/page2.jpg"
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/proof/page3.jpg"
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/proof/page4.jpg"
  })), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/proof/page5.jpg"
  }))));
};
export default ProofPage;